import React, { ReactNode, Ref } from 'react';

import classNames from 'classnames';

import classes from './ScrollBox.module.scss';
import { useScroll } from './hooks/useScroll';

type ScrollBoxProps = {
  children: ReactNode;
  maxHeight: number;
  className?: string;
  variant?: 'outBox' | 'inBox';
  /** always `maxHeight` tall, so the box doesn't resize while its content changes */
  isFixedHeight?: boolean;
  /** the element that scrolls - an IntersectionObserver `root`, e.g. for `useInfiniteScroll` */
  scrollRef?: Ref<HTMLDivElement>;
};

const ScrollBox = ({
  children,
  maxHeight,
  className,
  variant = 'inBox',
  isFixedHeight = false,
  scrollRef,
}: ScrollBoxProps) => {
  const { isScrollShown, boxContentRef } = useScroll(maxHeight);

  const boxWrapperClassNames = classNames(className, classes[variant], {
    [classes.withScrollIndent]: isScrollShown,
  });

  return (
    <div className={boxWrapperClassNames}>
      <div
        ref={scrollRef}
        className={classes.scrollBox}
        style={{ maxHeight: `${maxHeight}px` }}
      >
        <div
          ref={boxContentRef}
          className={classes.contentWrapper}
          style={{ minHeight: isFixedHeight ? `${maxHeight}px` : undefined }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export { ScrollBox };
